import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'vex-recipe-info',
  templateUrl: './recipe-info.component.html',
  styleUrls: ['./recipe-info.component.scss']
})
export class RecipeInfoComponent implements OnInit {
  @Input() data: any;
  environmentNode = environment.baseURL.node;

  constructor(private dialogRef: MatDialogRef<any>, public translate: TranslateService, @Inject(MAT_DIALOG_DATA) public datas: any) {
    this.data = datas.data;
  }

  ngOnInit() {
    console.debug(this.data)
  }

  closeModal() {
    this.dialogRef.close();
  }

  getItem(item: any): any {
    const tmp: any = item;
    return tmp;
  }

}
